import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { LgvGridManager } from '../../grid-manager/grid-manager';
import { LoanAppPageService } from '../../../core/services/page-services/loan-app-page.service';
import { LgvFormUtilityService } from '../../../core/services/lgv-form-utility.service';
import { LgvLoanApplicationService } from '../../../core/services/lgv-loan-application.service';

@Component({
    selector: 'lgv-loan-app-activities',
    templateUrl: './loan-app-activities.component.html',
    styleUrls: ['./loan-app-activities.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoanAppActivitiesComponent implements OnInit, OnDestroy {

    activityLogs$ = new BehaviorSubject(null);
    allActivityLogs = [];
    GridMgr: LgvGridManager;
    isLoading = false;
    onDestroy$ = new Subject();
    currentPage = 1;
    countPerPage = 25;
    totalCount = 0;
    searchText = '';
    loanAppId: string;

    constructor(private lgvLoanAppPageService: LoanAppPageService,
        private lgvLoanService: LgvLoanApplicationService
    ) { }

    ngOnInit(): void {
        this.GridMgr = new LgvGridManager();
        this.GridMgr.Init('date', 'desc');
        this.loanAppId = this.lgvLoanAppPageService.selectedLoanApplication$.value.id;
        this.fetchActivityLogs();

        this.GridMgr.OnRefreshData.pipe(takeUntil(this.onDestroy$)).subscribe(
            (refreshData) => {
                let sortedArray = [];
                console.log(refreshData?.data)
                if(refreshData?.data?.direction === 'asc') {
                    sortedArray = this.allActivityLogs.sort((a, b) => a[refreshData?.data?.column] > b[refreshData?.data?.column] ? 1 : -1);
                } else {
                    sortedArray = this.allActivityLogs.sort((a, b) => a[refreshData?.data?.column] < b[refreshData?.data?.column] ? 1 : -1);
                }
                this.activityLogs$.next(sortedArray);
            }
        );
    }

    ngOnDestroy(): void {
        this.onDestroy$.next(false);
        this.onDestroy$.complete();
    }

    fetchActivityLogs(searchText = null) {
        this.isLoading = true;

        //add logic for fetching filtered list
        this.lgvLoanService.fetchLoanAppActivities(this.loanAppId, searchText).pipe(takeUntil(this.onDestroy$)).subscribe((activityLogs) => {
            this.allActivityLogs = activityLogs;
            this.activityLogs$.next(activityLogs);
            if (!searchText) {
                this.countPerPage = 25;
            }
            if (activityLogs.length < this.countPerPage) {
                this.countPerPage = activityLogs.length;
            }
            this.totalCount = activityLogs?.length;
            this.isLoading = false;
        });
    }

    onSearch() {
        this.fetchActivityLogs(this.searchText)
    }

    getActionList(changes: string[]) {
        let stringChanges = '';
        for (let change of changes) {
            stringChanges += change + '<br>';
        }
        return stringChanges;
    }

    previousPage() {
        if (this.currentPage > 1) {
            this.currentPage - 1;
            const pageActivityLogs = this.allActivityLogs.slice(this.currentPage*this.countPerPage, (this.currentPage * this.countPerPage)+this.countPerPage)
            this.activityLogs$.next(pageActivityLogs)
            console.log('prev')
        }
    }

    nextPage() {
        if (this.currentPage < this.allActivityLogs.length/this.countPerPage) {
            this.currentPage + 1;
            const pageActivityLogs = this.allActivityLogs.slice(this.currentPage * this.countPerPage, (this.currentPage * this.countPerPage)+this.countPerPage)
            this.activityLogs$.next(pageActivityLogs)
            console.log('next')
        }
    }

}
